import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const privateLibraryLessonsPickerModalViewSelector = createSelector(
	[state => state.libraries.current],
	current => {
		const placeholder = current.settings.entity_type === 'school' ? localize('private_library_lessonsPicker_school_placeholder') : localize('private_library_lessonsPicker_district_placeholder')
		return {
			folderName: current.name,
			placeholder,
		}
	}
)

export default privateLibraryLessonsPickerModalViewSelector
